import { UserAppPreferencesService } from 'api/services/UserAppPreferencesService'
import { useDispatch } from 'react-redux'
import { setFloatingSidebar } from 'redux/actions'
import { useRootStore } from 'stores/RootStore'

export const useCloseLeftSidebar = () => {
  const rootStore = useRootStore()
  const dispatch = useDispatch()

  const closeLeftSidebar = () => {
    rootStore.leftSidebarStore.setIsHovered(false)
    UserAppPreferencesService.unlockSidebar()
    dispatch(setFloatingSidebar(false))
  }

  return { closeLeftSidebar }
}
